// extracted by mini-css-extract-plugin
export default {"searchBar":"InteractionSentiment_searchBar__eY4qe"};